import React, { useState } from "react";
import api from "../../api";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import SearchIcon from "@material-ui/icons/Search";
import { makeStyles } from "@material-ui/core/styles";
import {
  Paper,
  Grid,
  Table,
  TableHead,
  TableRow,
  TableContainer,
  TableBody,
  TableCell,
  Button,
  Dialog,
  DialogContent,
  TextField,
  IconButton,
} from "@material-ui/core";
import CreateIcon from "@material-ui/icons/Create";
import DeleteIcon from "@material-ui/icons/Delete";
import ConfirmDialog from "../common/confirmDialog/ConfirmDialog";
import utils from "../../utils/utils";
import Tooltip from '@material-ui/core/Tooltip';
import { useNavigate } from "react-router-dom";

export default function TypeAssist({ setIsLoading, setDataToast }) {
  let navigate = useNavigate();
  const [name, setName] = useState("");
  const [open, setOpen] = React.useState(false);
  const [error, setError] = useState(false);
  const [openEdit, setOpenEdit] = React.useState(false);

  //lista de asistencias
  const [dataTable, setDataTable] = useState();

  const [deleteDialog, setDeleteDialog] = useState({
    open: false,
    id: undefined,
  });

  const [viewData, setViewData] = useState();

  const [defaultValues, setDefaultValues] = useState({
    id: undefined,
    name: "",
  });

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleCloseEdit = () => {
    setOpenEdit(false);
  };

  const onClickCreate = () => {
    if (name.trim()) {
      var body = {
        nombre: name.trim(),
      };

      api
        .postTypeAssist(body)

        .then(() => {
          setIsLoading(false);
          setDataToast({
            active: true,
            message: "Tipo asistencia creada correctamente.",
            type: "success",
          });

          onClickVerList();
        })

        .catch((err) => {
          setIsLoading(false);
          setDataToast({
            active: true,
            message: err.response.data.errores ?? "Ocurrió un error.",
            type: "error",
          });
        });

      setError(false);
      handleClose();
    } else {
      setError(true);
    }
  };

  const handleImputChange = (e) => {
    setName(e.target.value);
  };

  const handleImputChangeEdit = (e) => {
    setDefaultValues({ ...defaultValues, name: e.target.value });
  };

  function onClickVerList() {
    setIsLoading(true);

    api
      .getTypesAssists(1)
      .then((res) => {
        setDataTable(res.data);
        setIsLoading(false);
      })

      .catch((err) => {
        setIsLoading(false);
        setDataToast({
          active: true,
          type: "error",
          message: "Ocurrió un error.",
        });
      });
  }

  function shortError(message) {
    setDataToast({
      active: true,
      message: message,
      type: "error",
    });
  }

  const search = (e) => {
    e.preventDefault();
    onClickVerList();
  }

  const closePreDelete = () => {
    setDeleteDialog({ ...deleteDialog, open: false });
  }

  const preDelete = (id) => {
    setDeleteDialog({ open: true, id: id });
  }

  function deleteAssist(id) {
    closePreDelete();
    setIsLoading(true);
    api
      .deleteTypeAssist(id)
      .then((res) => {
        let newDataTable = [];
        dataTable.forEach((nombre) => {
          if (nombre.id !== id) {
            newDataTable.push(nombre);
          }
        });

        setDataTable(newDataTable);
        setIsLoading(false);
        utils.alertSuccess("Asistencia N° " + id, "Eliminada correctamente.");
      })
      .catch((err) => {
        setIsLoading(false);
        if (err.response.data.errores) {
          utils.alertError("Asistencia N° " + id, err.response.data.errores);
        } else {
          shortError("Ocurrió un error");
        }
      });
  }

  function getTypeAssist(id) {
    setIsLoading(true);
    api
      .getTypeAssists(id)
      .then((res) => {
        let data = res.data;

        setDefaultValues({
          id: data.id,
          name: data.nombre,
        });
        setIsLoading(false);
        setOpenEdit(true);
        setViewData(true);
      })
      .catch((err) => {
        setIsLoading(false);
        setViewData(false);
        shortError("Ocurrió un error.");
      });
  }

  function save() {
    if (defaultValues.name.trim()) {
      setIsLoading(true);
      var body = {
        nombre: defaultValues.name.trim(),
      };

      api
        .putTypeAssist(defaultValues.id, body)
        .then((res) => {
          setIsLoading(false);
          setDataToast({
            active: true,
            message: "Asistencia editada correctamente.",
            type: "success",
          });
          onClickVerList();
        })

        .catch((err) => {
          setIsLoading(false);

          setDataToast({
            active: true,
            message: err.response.data.errores ?? "Ocurrió un error.",
            type: "error",
          });
        });

      setError(false);
      handleCloseEdit();
    } else {
      setError(true);
    }
  }

  const useStyles = makeStyles((theme) => ({
    root: {
      "& .MuiTextField-root": {
        margin: theme.spacing(1),
        width: 200,
      },
    },
  }));

  const classes = useStyles();

  return (
    <>
      <Paper className="c-grid" elevation={3}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Grid className="c-grid-header" container spacing={1}>
              <Grid item xs={6}>
                <h2>TIPOS DE ASISTENCIA</h2>
              </Grid>
              <Grid item xs={6}>
                <Button
                  variant="contained"
                  className="c-grid-btn c-btn-success"
                  color="primary"
                  onClick={handleClickOpen}
                >
                  Crear Nuevo
                </Button>

                <Dialog
                  open={open}
                  onClose={handleClose}
                  aria-labelledby="form-dialog-title"
                >
                  <DialogTitle id="form-dialog-title">Nuevo</DialogTitle>
                  <DialogContent>
                    <TextField
                      autoFocus
                      margin="dense"
                      id="name"
                      label="Nombre de la asistencia"
                      type="text"
                      name="nombre"
                      onChange={handleImputChange}
                      fullWidth
                      error={error}
                    />
                  </DialogContent>

                  <DialogActions>
                    <Button onClick={handleClose}
                      className="c-btn-cancel"
                    >
                      Cancelar
                    </Button>
                    <Button onClick={onClickCreate}
                      className="c-btn-success"
                    >
                      Aceptar
                    </Button>
                  </DialogActions>
                </Dialog>
              </Grid>

              <Grid item xs={12}>
                <form onSubmit={search}>
                  <Grid container spacing={1}>
                    <Grid item md={10} />
                    <Grid item md={2} xs={12}>
                      <Button
                        className="c-btn-info c-mt-2"
                        variant="contained"
                        fullWidth={true}
                        type="submit"
                        startIcon={<SearchIcon />}
                        onClick={() =>
                          navigate("/tipos-asistencias?estado=" + 1)
                        }
                      >
                        Buscar
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>

      {dataTable && dataTable.length > 0 && (
        <Paper className="c-mt-20 c-grid-results" elevation={3}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <TableContainer>
                <Table className="c-table" size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell className="c-w-10">
                        {" "}
                        N° de Asistencia{" "}
                      </TableCell>
                      <TableCell className="c-w-30">Nombre</TableCell>
                      <TableCell className="c-w-20">Opciones</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {dataTable.map(({ id, nombre }) => (
                      <TableRow key={id}>
                        <TableCell className="c-w-10">{id}</TableCell>
                        <TableCell className="c-w-30">{nombre}</TableCell>

                        <TableCell className="c-w-20">
                          <Tooltip title="Editar" arrow>
                            <IconButton
                              className="c-grid-btn-edit button-grid"
                              onClick={() => getTypeAssist(id)}
                            >
                              <CreateIcon />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Dar de baja" arrow>
                            <IconButton
                              className="c-grid-btn-cancel button-grid"
                              onClick={() => preDelete(id)}
                            >
                              <DeleteIcon />
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        </Paper>
      )}

      {dataTable && dataTable.length === 0 && (
        <Paper className="c-mt-20" elevation={3}>
          <Grid container spacing={1}>
            <Grid item xs={12} className="c-text-center">
              <h5>No se encontraron resultados.</h5>
            </Grid>
          </Grid>
        </Paper>
      )}

      {deleteDialog !== undefined && (
        <ConfirmDialog
          open={deleteDialog.open}
          message={"¿Desea eliminar la asistencia N° " + deleteDialog.id + " ?"}
          cancelAction={closePreDelete}
          confirmAction={() => deleteAssist(deleteDialog.id)}
        />
      )}

      {viewData && (
        <Dialog
          open={openEdit}
          onClose={handleCloseEdit}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">Editar</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              id="name"
              type="text"
              name="nombre"
              label="Nombre de la asistencia"
              onChange={handleImputChangeEdit}
              value={defaultValues.name}
              fullWidth
              error={error}
            />
          </DialogContent>

          <DialogActions>
            <Button onClick={handleCloseEdit}
              className="c-btn-cancel"
            >
              Cancelar
            </Button>

            <Button onClick={() => save()}
              className="c-btn-success"
            >
              Aceptar
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
}
